var _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgYoutubeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 51,
    viewBox: "0 0 49 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.8,
    d: "M24.1345 50.5101C37.4636 50.5101 48.269 39.7047 48.269 26.3756C48.269 13.0464 37.4636 2.24106 24.1345 2.24106C10.8054 2.24106 0 13.0464 0 26.3756C0 39.7047 10.8054 50.5101 24.1345 50.5101Z",
    fill: "url(#paint0_radial_54_316)"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.4434 24.87V8.8493C34.4434 3.99369 30.5071 0.0574341 25.6515 0.0574341L9.63078 0.0574341C4.77517 0.0574341 0.838924 3.99369 0.838924 8.8493V24.87C0.838924 29.7256 4.77517 33.6619 9.63078 33.6619H25.6515C30.5071 33.6619 34.4434 29.7256 34.4434 24.87Z",
    fill: "#005A92"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.6399 14.4232C26.6399 13.3534 26.2149 12.3273 25.4584 11.5708C24.7019 10.8143 23.6759 10.3893 22.606 10.3893H12.2627C11.1928 10.3893 10.1668 10.8143 9.41025 11.5708C8.65375 12.3273 8.22876 13.3534 8.22876 14.4232V19.2272C8.22876 19.7569 8.3331 20.2814 8.53582 20.7709C8.73854 21.2603 9.03567 21.705 9.41025 22.0796C9.78484 22.4541 10.2295 22.7513 10.719 22.954C11.2084 23.1567 11.7329 23.2611 12.2627 23.2611H22.606C23.1358 23.2611 23.6603 23.1567 24.1497 22.954C24.6391 22.7513 25.0839 22.4541 25.4584 22.0796C25.833 21.705 26.1301 21.2603 26.3329 20.7709C26.5356 20.2814 26.6399 19.7569 26.6399 19.2272V14.4232ZM20.5718 17.1815L15.9748 19.48C15.8024 19.5719 15.1818 19.48 15.1818 19.2386V14.5382C15.1818 14.3313 15.8024 14.1934 15.9863 14.2968L20.4109 16.7103C20.5604 16.8137 20.7557 17.0895 20.5718 17.2045V17.1815Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_54_316",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(24.1345 26.3756) scale(24.1345)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#000056"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#7373A2",
    stopOpacity: 0.55
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#D9D9E6",
    stopOpacity: 0.15
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutubeIcon);
export default __webpack_public_path__ + "static/media/Youtube Icon.b34fa5a4ec603fd230b36480a9085086.svg";
export { ForwardRef as ReactComponent };